import React, { useState, useEffect } from 'react';

const EditConfig = ({ config, onSave }) => {
    const [error, setError] = useState('');
    const [value, setValue] = useState(config.value);

    useEffect(() => {
        setValue(config.value);
    }, [config]);

    const handleSave = () => {
        onSave(config.key, value);
    };

    const handleEdit = (e) => {
        e.preventDefault();
        try {
            const jsonValue = JSON.parse(e.target.value);
            setError('');
            setValue(jsonValue);
        } catch (error) {
            setError('Not valid format')
        }
    }

    const getType = (value) => {
        if (Array.isArray(value)) return 'array';
        return typeof value;
    };

    const renderInputField = () => {
        const type = getType(value);

        switch (type) {
            case 'string':
                return (
                    <div>
                        <textarea
                            className='editconfig-textarea'
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        {error && <p className='form-error'>{error}</p>}
                    </div>
                );
            case 'array':
                return (
                    <div>
                        <textarea
                            className='editconfig-textarea'
                            // value={JSON.stringify(value, null, 2)}
                            onChange={handleEdit}
                        >
                        {JSON.stringify(value, null, 2)}
                        </textarea>
                        {error && <p className='form-error'>{error}</p>}
                    </div>
                );
            case 'object':
                return (
                    <div>
                        <textarea
                            className='editconfig-textarea'
                            // value={JSON.stringify(value, null, 2)}
                            onChange={handleEdit}
                        >
                        {JSON.stringify(value, null, 2)}
                        </textarea>
                        {error && <p className='form-error'>{error}</p>}
                    </div>
                );
            default:
                return <input type="text" value={value} onChange={(e) => setValue(e.target.value)} />;
        }
    };

    return (
        <div>
            <h3>Edit Config: {config.key}</h3>
            {renderInputField()}
            <button className='small-button' onClick={handleSave}>Save</button>
        </div>
    );
};

export default EditConfig;
